import { FC, ReactNode, useState } from 'react'
import { Box, Tab, Tabs } from '@mui/material'
import { EGameVariant } from '../../constants/gameVariant'

type GameVariantTabViewsProps = {
  tabContent: Record<EGameVariant, ReactNode>
}

const GameVariantTabViews: FC<GameVariantTabViewsProps> = (props) => {
  const [tab, setTab] = useState<EGameVariant>(EGameVariant.ROULETTE)

  return (
    <>
      <Tabs
        value={tab}
        onChange={(_, value) => {
          setTab(value)
        }}>
        <Tab label="Рулетка" value={EGameVariant.ROULETTE} />
        <Tab label="Русский покер" value={EGameVariant.RUSSIAN_POKER} />
      </Tabs>

      <Box pt={2}>{props.tabContent[tab]}</Box>
    </>
  )
}

export default GameVariantTabViews
